<template>
  <div>
    <infoDetailsLeft></infoDetailsLeft>
  </div>
</template>
<script>
import infoDetailsLeft from '@/views/newGroup/children/infoPublicityDetails/infoDetailsLeft.vue';
export default {
  components: {
    infoDetailsLeft
  },
  data() {
    return{
     
    }
  },
  created() {
  
  },
  methods:{
   
  }
}
</script>
<style scoped lang="scss">

</style>
